<div style="margin-top: 10px;" id="strength">
  <i class="custom-icon-button1"></i>
  <small style="margin-left: 10px;">{{ barLabel }}</small>

  <!-- Display the message only if unmetCriteria has items -->
  <p
    *ngIf="unmetCriteria.length > 0"
    style="margin-top: 10px; color: gray; font-size: 14px;"
  >
    Password must meet the criteria below.
  </p>

  <!-- Strength Bar -->
  <ul id="strengthBar">
    <li
      class="point"
      *ngFor="let color of colorList"
      [style.background-color]="color"
    ></li>
  </ul>

  <!-- Unmet Criteria -->
  <ul style="margin-top: 10px; color: red;" *ngIf="unmetCriteria.length > 0">
    <li *ngFor="let criterion of unmetCriteria">{{ criterion }}</li>
  </ul>
</div>
